import { Box, Center } from '@mantine/core'
import { IoConstructOutline } from 'react-icons/io5'

type Props = {
  /** Main/cover photo URL from list API */
  url?: string | null;
  alt?: string;
  /** Wide hero strip on dashboard cards; compact row thumb on profile/registry lists */
  variant?: 'full' | 'compact';
};

export default function BuildCardThumbnail ({ url, alt = '', variant = 'full' }: Props) {
  const h = variant === 'full' ? 140 : 72
  const w = variant === 'compact' ? 96 : '100%'

  return (
    <Box
      sx={{
        width: w,
        height: h,
        flexShrink: 0,
        borderRadius: 8,
        overflow: 'hidden',
        background: 'var(--gs-surface2)'
      }}
    >
      {url
        ? (
        <Box
          component="img"
          src={url}
          alt={alt}
          sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
          )
        : (
        <Center sx={{ width: '100%', height: '100%', color: 'var(--gs-muted)' }}>
          <IoConstructOutline size={variant === 'full' ? 36 : 24} />
        </Center>
          )}
    </Box>
  )
}
